import { render, staticRenderFns } from "./ckeditor5.vue?vue&type=template&id=a004b8f6&"
import script from "./ckeditor5.vue?vue&type=script&lang=js&"
export * from "./ckeditor5.vue?vue&type=script&lang=js&"
import style0 from "./ckeditor5.vue?vue&type=style&index=0&id=a004b8f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports